

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Tagcategories',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Tagcategories",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'tagcategories/TAGCATEGORY_SET_TAGCATEGORY',                                    
                                items:'tagcategories/tagcategories',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Name',
                                        value: 'name',
                                        sortable:false
                                    },                                                
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};